import { z } from 'zod'

// Account-level e-mail notification preferences.
// GET /account/notification-prefs returns the full shape; PUT accepts either/both fields.
export const NotificationPrefs = z.object({
  vserver_down: z.boolean(),
  vserver_disk_usage: z.boolean()
})
export type NotificationPrefs = z.infer<typeof NotificationPrefs>

export const NotificationPrefsUpdateRequest = z.object({
  vserver_down: z.boolean().optional(),
  vserver_disk_usage: z.boolean().optional()
})
export type NotificationPrefsUpdateRequest = z.infer<typeof NotificationPrefsUpdateRequest>
